import apiClient from 'apiClient/index';
import { useEffect, useState } from 'react';

import { ISocialShareButtonList } from './type';

const LIHP_SOCIAL_SHARE_BUTTONS_LIST_ID = 'cmc3cqi957iga07livzuudmu0' as const;

const useGetSocialShareButtons = (id: string = LIHP_SOCIAL_SHARE_BUTTONS_LIST_ID) => {
  const [socialShareButtonList, setSocialShareButtonList] = useState<ISocialShareButtonList>();

  useEffect(() => {
    const get = async () => {
      const { data } = await apiClient.socialShare.getSocialShareButtonList(id);

      setSocialShareButtonList(data.data.socialShareButtonList);
    };

    get();
  }, [id]);

  return { socialShareButtonList };
};

export default useGetSocialShareButtons;
